import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home/Home';
import { Header } from './components/Header';
import Tracking from './pages/Tracking/Tracking';
// import { Footer } from './components/Footer';
import Service from './pages/Services/Service';
import LogisticsBanner from './pages/Services/LogisticsBanner';
import HomeBanner from './pages//Home/HomeBanner';
import About from './pages/About/About';
import Contact from './pages/ContcatUs/ContactUs';
import Solution from './pages/Solution/Solution';
// import { AboutComponent } from './pages/Home/AboutComponent';
import ScrollToTop from "./components/ScrollToTop";

export const Router = () => {
    return (
        <BrowserRouter>
        <ScrollToTop /> 
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/tracking" element={<Tracking />} />
                <Route path="/Service" element={<Service />} />
                <Route path="/LogisticsBanner" element={<LogisticsBanner />} />
                <Route path="/HomeBanner" element={<HomeBanner/>} />
                <Route path="/About" element={<About/>} />
                <Route path="/Contact" element={<Contact />} />
                <Route path="/Solution" element={<Solution />} />
               {/* <Route path='/AboutComponent' element={<AboutComponent/>} /> */}
            </Routes>
            {/* <Footer/> */}
        </BrowserRouter>
    )
}   

